import { Icon } from '@chakra-ui/react';
import type { IconProps } from '@chakra-ui/react';

const SearchIcon = (props: Omit<IconProps, 'children' | 'viewBox'>) => (
  <Icon
    height='100%'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    viewBox='0 0 24 24'
    width='100%'
    {...props}
  >
    <path
      stroke='none'
      d='M0 0h24v24H0z'
      fill='none'
    />
    <path d='M10 10m-7 0a7 7 0 1 0 14 0a7 7 0 1 0 -14 0' />
    <path d='M21 21l-6 -6' />
  </Icon>
);

export default SearchIcon;
